import { t } from '../i18n';

export const formatEvaluationPlanDisplayName = (evalPlan = {}) => {
  const name = evalPlan.name || '';
  const seriesPosition = evalPlan.seriesPosition;

  if (!evalPlan.seriesParentId || !seriesPosition) {
    return name;
  }

  const suffix = `(${seriesPosition})`;
  return name.trim().endsWith(suffix) ? name : `${name} ${suffix}`;
};

export const getEvaluationPlanBaseName = (evalPlan = {}) => {
  const name = evalPlan.name || '';
  const seriesPosition = evalPlan.seriesPosition;

  if (!evalPlan.seriesParentId || !seriesPosition) {
    return name;
  }

  return name.replace(new RegExp(`\\s*\\(${seriesPosition}\\)$`), '');
};

export const getNextEvaluationPlanName = (evaluationPlans = []) => {
  const usedNumbers = new Set();

  evaluationPlans.forEach((evalPlan) => {
    const baseName = formatEvaluationPlanDisplayName(evalPlan).replace(
      /\s*\(\d+\)$/,
      ''
    );
    const match = baseName.match(/^Evaluation Plan(?:\s+(\d+))?$/i);

    if (match) {
      usedNumbers.add(match[1] ? Number(match[1]) : 1);
    }
  });

  let nextNumber = 1;
  while (usedNumbers.has(nextNumber)) {
    nextNumber += 1;
  }

  return `${t('activity.evaluation.evaluation_plan')} ${nextNumber}`;
};
